import React, { useCallback, useState, useRef } from 'react'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import { useFocusEffect } from '@react-navigation/native'
import { View, StyleSheet } from 'react-native'
import RecurringTractorModal from '../RecurringTractorModal'
import Filters from '../RecurringTractorsFilters'
import { ListWithInfiniteScroll, Spinner, IconButton, ConfirmationDialog, FilterMenu, RecurringTractorCard, Button } from '../../../../components'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import * as recurringActions from '../../../../redux/tractors/recurringActions'
import { recurringSelector } from '../../../../redux/tractors/recurringSelector'
import { setRecurringPayload } from '../../helpers'
ReactGA.pageview('/main/tractors/recurring')

const RecurringTractor = () => {
  const { isTablet } = usePlatforms()
  const { recurrings, noMore, loadMore, loadPage, filters, deleteLoad } = useSelector(recurringSelector)
  const dispatch = useDispatch()
  const [modalParams, setModalParams] = useState({
    openRecurringTractorModal: false,
    recurringTractor: null,
    openConfirmationModal: false
  })

  const modalRef = useRef(null)

  useFocusEffect(
    useCallback(() => {
      return () => { dispatch(recurringActions.setFilters({ offset: 0 })) }
    }, [dispatch])
  )

  const getRecurring = useCallback(() => {
    const body = setRecurringPayload(filters)
    const { offset } = filters
    dispatch(recurringActions.getRecurring({ offset, body }))
  }, [dispatch, filters])

  useFocusEffect(getRecurring)

  const handleLoadMore = useCallback(() => {
    if (noMore || loadMore) return
    dispatch(recurringActions.loadMore(1))
  }, [dispatch, loadMore, noMore])

  const clearFilters = useCallback(() => {
    dispatch(recurringActions.setFilters())
  }, [dispatch])

  const handleSearch = useCallback((payload) => {
    dispatch(recurringActions.setFilters({
      ...payload
    }))
  }, [dispatch])

  const onOpen = () => {
    const { current = null } = modalRef
    current && current.open()
  }

  const onClose = () => {
    const { current = null } = modalRef
    current && current.close()
  }

  const onEditTractor = recurringTractor => {
    setModalParams({ openTractorModal: true, recurringTractor })
  }

  const onDeleteTractor = recurringTractor => {
    setModalParams(prev => ({ ...prev, openConfirmationModal: true, recurringTractor }))
  }

  const onCloseModal = useCallback(() => {
    setModalParams({
      openTractorModal: false,
      openConfirmationModal: false,
      recurringTractor: null
    })
  }, [])

  const handleConfirmationDialog = useCallback((action) => {
    if (action) {
      dispatch(recurringActions.deleteRecurringTractor(modalParams.recurringTractor.recurring_tractor_id, onCloseModal))
    } else {
      onCloseModal()
    }
  }, [onCloseModal, dispatch, modalParams])

  return (
    <View style={{ flex: 1, paddingVertical: isTablet ? 10 : 20, paddingHorizontal: 10 }}>
      {!isTablet && (
        <FilterMenu
          openFilters={onOpen}
          handleClearFilters={clearFilters}
          applyFilters={setRecurringPayload(filters)}
        />
      )}
      <Filters
        initialValues={filters}
        onClose={onClose}
        handleSearch={handleSearch}
        handleClearFilters={clearFilters}
        modalRef={modalRef}
      />
      {isTablet && (
        <View style={styles.addButtonLargeContainer}>
          <Button
            title='Add Capacity'
            onPress={() => onEditTractor()}
            style={styles.addButtonLarge}
          />
        </View>
      )}
      {loadPage ? (
        <Spinner />
      ) : (
        <ListWithInfiniteScroll
          data={recurrings || []}
          component={RecurringTractorCard}
          noMore={noMore}
          handleLoadMore={handleLoadMore}
          loading={loadMore}
          cardProps={{
            editTractor: onEditTractor,
            deleteTractor: onDeleteTractor
          }}
          noDataMessage='No recurring tractors found'
        />)}
      {!isTablet && (
        <View style={styles.addButton}>
          <IconButton
            color='AZTEC'
            icon='Plus'
            size={40}
            iconSize={20}
            onPress={() => onEditTractor()}
          />
        </View>
      )}
      <RecurringTractorModal
        open={modalParams.openTractorModal}
        recurringTactorToEdit={modalParams.recurringTractor}
        onClose={onCloseModal}
      />
      <ConfirmationDialog
        open={modalParams.openConfirmationModal}
        title='Delete Recurring tractor'
        description='Are sure you want to delete this recurring tractor?'
        onClose={handleConfirmationDialog}
        loading={deleteLoad}
      />
    </View>

  )
}

const styles = StyleSheet.create({
  addButton: {
    position: 'absolute',
    right: 20,
    bottom: 20
  },
  addButtonLargeContainer: {
    alignItems: 'flex-end',
    marginBottom: 10
  },
  addButtonLarge: {
    width: 150,
    height: 25
  }
})

export default RecurringTractor
